export class DinnersCard {

    public static isDinners(card: string): boolean {
        return /^3(0[0-5]|[68]\d)\d{11}/.test(card) && card.length === 14
    }

}